/**
 * PDP Event Handler
 * - Countdown timer for preorder/release/draw/lottery
 * - Release mode: NOTIFY -> ADD TO CART transition
 * - Release: Klaviyo notify signup
 * - Release: Size stock indicators
 *
 * Date format: YYYYMMDD (8) or YYYYMMDDTHHmm (13), always KST (+09:00)
 */
(function() {
  'use strict';

  var KST_OFFSET = '+09:00';

  /**
   * Parse raw date string into a Date object (KST)
   * Supports: 20260414 (8 chars), 2026-04-14 (10 chars), 20260414T0700 (13 chars)
   */
  function parseTargetDate(raw) {
    if (!raw) return null;
    var year, month, day, hour, min;

    if (raw.length === 13 && raw.charAt(8) === 'T') {
      year = raw.slice(0, 4);
      month = raw.slice(4, 6);
      day = raw.slice(6, 8);
      hour = raw.slice(9, 11);
      min = raw.slice(11, 13);
    } else if (raw.length === 8) {
      year = raw.slice(0, 4);
      month = raw.slice(4, 6);
      day = raw.slice(6, 8);
      hour = '00';
      min = '00';
    } else if (raw.length === 10) {
      year = raw.slice(0, 4);
      month = raw.slice(5, 7);
      day = raw.slice(8, 10);
      hour = '00';
      min = '00';
    } else {
      return null;
    }

    var dateStr = year + '-' + month + '-' + day + 'T' + hour + ':' + min + ':00' + KST_OFFSET;
    var d = new Date(dateStr);
    return isNaN(d.getTime()) ? null : d;
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* ========================================
     1. PDP Event Header Countdown Timer
     ======================================== */
  function initPdpCountdown() {
    var headers = document.querySelectorAll('.pdp-event-header__countdown');
    if (!headers.length) return;

    headers.forEach(function(el) {
      var raw = el.getAttribute('data-preorder-end');
      var targetDate = parseTargetDate(raw);
      if (!targetDate) return;

      updateCountdown(el, targetDate);
      setInterval(function() {
        updateCountdown(el, targetDate);
      }, 1000);
    });
  }

  function updateCountdown(el, targetDate) {
    var now = new Date();
    var diff = targetDate - now;

    if (diff <= 0) {
      // Auto-hide the entire event header when date passes
      var header = el.closest('.pdp-event-header');
      if (header) header.style.display = 'none';
      handleReleaseTransition();
      return;
    }

    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var secs = Math.floor((diff % (1000 * 60)) / 1000);

    el.querySelector('.timer-days').textContent = pad(days);
    el.querySelector('.timer-hours').textContent = pad(hours);
    el.querySelector('.timer-mins').textContent = pad(mins);
    el.querySelector('.timer-secs').textContent = pad(secs);
  }

  /* ========================================
     2. Release Mode Transition
     ======================================== */
  function handleReleaseTransition() {
    var notifyContainers = document.querySelectorAll('.pdp-release-notify');
    notifyContainers.forEach(function(container) {
      var raw = container.getAttribute('data-release-date');
      var targetDate = parseTargetDate(raw);
      if (!targetDate) return;

      if (new Date() >= targetDate) {
        container.style.display = 'none';
        var sectionId = container.id.replace('pdp-release-notify-', '');
        var cartForm = document.getElementById('pdp-release-cart-' + sectionId);
        if (cartForm) cartForm.style.display = 'block';
      }
    });
  }

  /* ========================================
     3. NOTIFY Button - Klaviyo Integration
     ======================================== */
  function initNotifyButtons() {
    var notifyContainers = document.querySelectorAll('.pdp-release-notify');
    notifyContainers.forEach(function(container) {
      var sectionId = container.id.replace('pdp-release-notify-', '');
      var notifyBtn = document.getElementById('pdp-notify-btn-' + sectionId);
      var notifyForm = document.getElementById('pdp-notify-form-' + sectionId);
      var submitBtn = document.getElementById('pdp-notify-submit-' + sectionId);
      var successMsg = document.getElementById('pdp-notify-success-' + sectionId);
      var emailInput = document.getElementById('pdp-notify-email-' + sectionId);
      var phoneInput = document.getElementById('pdp-notify-phone-' + sectionId);

      if (!notifyBtn || !notifyForm) return;

      notifyBtn.addEventListener('click', function() {
        notifyBtn.style.display = 'none';
        notifyForm.style.display = 'flex';
        if (emailInput) emailInput.focus();
      });

      if (submitBtn) {
        submitBtn.addEventListener('click', function() {
          var email = emailInput ? emailInput.value.trim() : '';
          var phone = phoneInput ? phoneInput.value.trim() : '';

          if (!email) {
            emailInput.style.borderColor = '#B7273E';
            return;
          }
          emailInput.style.borderColor = '#E9E6E0';

          var productTitle = container.getAttribute('data-product-title') || '';
          var productUrl = container.getAttribute('data-product-url') || '';
          var raw = container.getAttribute('data-release-date') || '';

          // Build ISO date for Klaviyo (KST)
          var targetDate = parseTargetDate(raw);
          var isoDate = targetDate ? targetDate.toISOString() : '';

          // Klaviyo track event
          if (typeof klaviyo !== 'undefined' && klaviyo.push) {
            klaviyo.push(['identify', { '$email': email, '$phone_number': phone || undefined }]);
            klaviyo.push(['track', 'Release Notify Signup', {
              'product_title': productTitle,
              'product_url': window.location.origin + productUrl,
              'release_date': isoDate,
              'email': email,
              'phone': phone
            }]);
          }

          submitBtn.disabled = true;
          submitBtn.querySelector('span').textContent = submitBtn.dataset.labelSubmitted || 'SUBMITTED';
          if (successMsg) successMsg.style.display = 'block';
          if (emailInput) emailInput.disabled = true;
          if (phoneInput) phoneInput.disabled = true;
        });
      }
    });
  }

  /* ========================================
     4. Size Stock Indicators (Release)
     ======================================== */
  function initStockIndicators() {
    var stockContainers = document.querySelectorAll('.pdp-release-notify__stock-info');
    if (!stockContainers.length) return;

    document.addEventListener('change', function(e) {
      if (!e.target.closest('variant-radios')) return;
      setTimeout(updateStockDisplay, 50);
    });

    var variantInputs = document.querySelectorAll('input[name="id"]');
    variantInputs.forEach(function(input) {
      var observer = new MutationObserver(function() { updateStockDisplay(); });
      observer.observe(input, { attributes: true, attributeFilter: ['value'] });
    });

    updateStockDisplay();
  }

  function updateStockDisplay() {
    var stockContainers = document.querySelectorAll('.pdp-release-notify__stock-info');
    stockContainers.forEach(function(container) {
      var items = container.querySelectorAll('.pdp-release-notify__stock-item');
      var currentVariantId = '';
      var variantInput = document.querySelector('product-form input[name="id"]');
      if (variantInput) currentVariantId = variantInput.value;

      items.forEach(function(item) {
        if (item.getAttribute('data-variant-id') === currentVariantId) {
          var inventory = parseInt(item.getAttribute('data-inventory'), 10);
          item.style.display = (inventory <= 5 && inventory > 0) ? 'inline' : 'none';
        } else {
          item.style.display = 'none';
        }
      });
    });
  }

  /* ========================================
     5. Add stock labels next to size buttons (Release)
     ======================================== */
  function addSizeStockLabels() {
    var notifyContainers = document.querySelectorAll('.pdp-release-notify');
    if (!notifyContainers.length) return;

    var variantScript = document.querySelector('variant-radios script[type="application/json"]');
    if (!variantScript) return;

    var variants;
    try { variants = JSON.parse(variantScript.textContent); } catch(e) { return; }

    var fieldsets = document.querySelectorAll('.product-form__input--radios');
    fieldsets.forEach(function(fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      if (legend.textContent.trim().toLowerCase() !== 'size') return;

      var labels = fs.querySelectorAll('label');
      labels.forEach(function(label) {
        var input = label.querySelector('input') || document.getElementById(label.getAttribute('for'));
        if (!input) return;
        var val = input.value;

        var matchedVariant = variants.find(function(v) {
          return v.option1 === val || v.option2 === val;
        });
        if (!matchedVariant) return;
        var qty = matchedVariant.inventory_quantity;
        if (qty === null || qty === undefined) return;

        var existing = label.querySelector('.variant-stock-indicator');
        if (existing) existing.remove();

        if (qty <= 0) {
          label.style.opacity = '0.4';
          label.style.textDecoration = 'line-through';
        } else if (qty === 1) {
          var span = document.createElement('span');
          span.className = 'variant-stock-indicator';
          span.textContent = (window.__pdpI18n && window.__pdpI18n.oneLeft) || 'One Left';
          label.appendChild(span);
        } else if (qty <= 5) {
          var span = document.createElement('span');
          span.className = 'variant-stock-indicator';
          span.textContent = (window.__pdpI18n && window.__pdpI18n.fewLeft) || 'Few Left';
          label.appendChild(span);
        }
      });
    });
  }

  /* ========================================
     6. Color swatch -> Main image swap
     ----------------------------------------
     Bug fix: When a client has not linked variants to specific media in
     the Shopify admin (variant.featured_media is null), clicking a color
     swatch did NOT change the main product image. The theme's built-in
     VariantSelects.updateMedia() in global.js early-returns whenever
     featured_media is missing.

     This handler runs in addition to (not instead of) the theme JS and
     uses three fallback strategies, in order:
       1. variant.featured_media (already covered by global.js, kept for
          safety in case timing differs).
       2. Match a media item whose alt text contains the color value.
       3. Positional mapping: color value index -> media slide index
          (works when there is one media per color, in matching order).
     ======================================== */
  function getColorOptionInfo(variantRadios) {
    if (!variantRadios) return null;
    var colorTrigger = '';
    var triggerEl = document.querySelector('[data-color-trigger]');
    if (triggerEl) colorTrigger = (triggerEl.getAttribute('data-color-trigger') || '').toLowerCase();

    var fieldsets = variantRadios.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, .select-label');
      var labelText = legend ? legend.textContent.trim().toLowerCase() : '';
      // Strip trailing colon and value (e.g. "Color: Black")
      var name = labelText.split(':')[0].trim();
      if (
        name === 'color' || name === 'colour' || name === '\uC0C9\uC0C1' ||
        (colorTrigger && name === colorTrigger)
      ) {
        var inputs = Array.from(fieldsets[i].querySelectorAll('input[type="radio"]'));
        var values = inputs.map(function(inp) { return inp.value; });
        var checkedInput = inputs.find(function(inp) { return inp.checked; });
        return {
          fieldset: fieldsets[i],
          inputs: inputs,
          values: values,
          checkedValue: checkedInput ? checkedInput.value : null,
          checkedIndex: checkedInput ? inputs.indexOf(checkedInput) : -1,
          position: i + 1
        };
      }
    }
    return null;
  }

  function findMediaIdForColor(variantRadios, colorInfo) {
    if (!colorInfo) return null;
    var sectionId = variantRadios.dataset.section;

    // Strategy 1: variant.featured_media via JSON
    try {
      var script = variantRadios.querySelector('script[type="application/json"]');
      if (script) {
        var variants = JSON.parse(script.textContent);
        var match = variants.find(function(v) {
          return v.options && v.options.indexOf(colorInfo.checkedValue) !== -1 && v.featured_media;
        });
        if (match && match.featured_media) {
          return sectionId + '-' + match.featured_media.id;
        }
      }
    } catch (e) {}

    // Build a list of unique media items across the document. There can be
    // several galleries on the page (main + sub thumbnail strip + duplicates)
    // but they all share the same data-media-id values, so dedup is sufficient.
    var allMediaItems = Array.from(
      document.querySelectorAll('.product__media-item[data-media-id]')
    );
    var seen = {};
    var uniqueMedia = [];
    allMediaItems.forEach(function(item) {
      var id = item.getAttribute('data-media-id');
      if (id && !seen[id]) { seen[id] = true; uniqueMedia.push(item); }
    });

    if (!uniqueMedia.length) return null;

    var colorVal = (colorInfo.checkedValue || '').toLowerCase();

    // Strategy 2: alt text contains color value (or any of its parts)
    var parts = colorVal.split(/[\/\s]+/).filter(function(p) { return p && p.length > 1; });
    for (var m = 0; m < uniqueMedia.length; m++) {
      var img = uniqueMedia[m].querySelector('img');
      var alt = img && img.alt ? img.alt.toLowerCase() : '';
      if (!alt) continue;
      if (alt.indexOf(colorVal) !== -1) return uniqueMedia[m].getAttribute('data-media-id');
      for (var p = 0; p < parts.length; p++) {
        if (alt.indexOf(parts[p]) !== -1) return uniqueMedia[m].getAttribute('data-media-id');
      }
    }

    // Strategy 3: positional mapping (color index -> media index)
    if (
      colorInfo.checkedIndex >= 0 &&
      colorInfo.checkedIndex < uniqueMedia.length &&
      colorInfo.values.length === uniqueMedia.length
    ) {
      return uniqueMedia[colorInfo.checkedIndex].getAttribute('data-media-id');
    }

    return null;
  }

  function showMediaById(mediaId) {
    if (!mediaId) return false;
    var changed = false;
    var wrappers = document.querySelectorAll(
      '.product__media-wrapper, .global-variant-slider, .quick-product__media-list'
    );
    wrappers.forEach(function(wrapper) {
      var styles = window.getComputedStyle(wrapper);
      if (styles.display === 'none' || styles.visibility === 'hidden') return;
      var target = wrapper.querySelector('[data-media-id="' + mediaId + '"]');
      if (!target) return;

      // Iterate possible main-gallery slider roots in priority order. We
      // CANNOT use one querySelector with multiple selectors because that
      // returns DOM-order, not selector-order, and the thumbnail sublist
      // often appears before the main gallery in the markup.
      var sliderRootSelectors = [
        '.js-media-list',
        '.global-variant-js-media-list',
        '.product__media--scroll',
        '.quick-js-media-list'
      ];
      var moved = false;
      for (var s = 0; s < sliderRootSelectors.length && !moved; s++) {
        var sliderRoot = wrapper.querySelector(sliderRootSelectors[s]);
        if (!sliderRoot || !sliderRoot.swiper) continue;
        var slides = Array.from(sliderRoot.swiper.slides);
        var slideTarget = sliderRoot.querySelector('[data-media-id="' + mediaId + '"]');
        var idx = slideTarget ? slides.indexOf(slideTarget) : -1;
        if (idx !== -1) {
          sliderRoot.swiper.slideTo(idx);
          moved = true;
          changed = true;
        }
      }

      // Fallback: no swiper - manually prepend the matching element
      if (!moved) {
        var parent = target.parentElement;
        if (parent) {
          parent.prepend(target);
          window.setTimeout(function() { parent.scroll(0, 0); }, 0);
          changed = true;
        }
      }

      // Also sync the thumbnail sublist (uses data-media-sub-id)
      var subRoot = wrapper.querySelector('.product__media-sublist');
      if (subRoot && subRoot.swiper) {
        var subTarget = subRoot.querySelector('[data-media-sub-id="' + mediaId + '"]');
        if (subTarget) {
          var subSlides = Array.from(subRoot.swiper.slides);
          var subIdx = subSlides.indexOf(subTarget);
          if (subIdx !== -1) subRoot.swiper.slideTo(subIdx);
        }
      }
    });
    return changed;
  }

  function initColorSwatchMediaSwap() {
    var pickers = document.querySelectorAll('variant-radios[data-section]');
    if (!pickers.length) return;

    pickers.forEach(function(picker) {
      // Capture so we run before the theme's onVariantChange (also bound to 'change')
      // Using bubble phase + setTimeout 0 to run after the theme handler so we
      // override its (no-op) result rather than fight it.
      picker.addEventListener('change', function(e) {
        if (!e.target || e.target.type !== 'radio') return;
        // Only act when the changed radio belongs to the color option
        var colorInfo = getColorOptionInfo(picker);
        if (!colorInfo) return;
        // Determine if the changed input is in the color fieldset
        if (!colorInfo.fieldset.contains(e.target)) return;

        setTimeout(function() {
          var mediaId = findMediaIdForColor(picker, colorInfo);
          showMediaById(mediaId);
        }, 0);
      });
    });
  }

  /* ========================================
     Init
     ======================================== */
  function init() {
    initPdpCountdown();
    handleReleaseTransition();
    initNotifyButtons();
    initStockIndicators();
    addSizeStockLabels();
    initColorSwatchMediaSwap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
